// extracted by mini-css-extract-plugin
export default {"root":"styles_root__oVRN0","popup":"styles_popup__f9luf"};